<script>
  export let options;
  export let offset = 0;
</script>

<style>
  :root {
    --ulterra-teal: rgb(0, 146, 159);
    --google-grey: #5f6368;
    --original-grey: #888;
    --ulterra-logo-grey: rgb(76, 78, 85);
    --bottom-dead-space: 25px;
    --main-background-color: rgb(239, 239, 239);
  }
  .toggle {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 75px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    border-top: 1px solid darkgrey;
    background-color: var(--main-background-color);
  }

  button {
    margin-top: 0;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: var(--bottom-dead-space);
    width: 33.33%;
    height: calc(100% - var(--bottom-dead-space));
    line-height: 1;
    color: var(--google-grey);
    border-left: none;
    border-right: none;
    border-bottom: none;
    border-top: 2px solid var(--main-background-color);
    background-color: var(--main-background-color);
  }

  .selected {
    border-top: 2px solid var(--ulterra-teal);
    color: var(--ulterra-teal);
  }

  button:focus,
  button:active:focus {
    outline: none !important;
    outline-style: none;
  }
  #bottom-dead-space {
    position: fixed;
    bottom: 0;
    height: var(--bottom-dead-space);
    background-color: var(--main-background-color);
  }
</style>

<div class="toggle">
  {#each options as option, index}
    <button class:selected={offset === index} on:click={() => (offset = index)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class={option.class}>
        <path d={option.path_d}></path>
        <path d={option.path_d2}></path>
        <polyline points={option.polyline}></polyline>
      </svg>
      {option.label}
    </button>
  {/each}
  <div id="bottom-dead-space" />
</div>
